import styled from 'styled-components'

export const Container = styled.div`
margin: 20px 0;
`

export const StyledHeader = styled.div`
display: grid;
grid-template-columns: 1fr 3fr;
align-items: center;
& img {
    transition: transform .5s ease;
    transition-delay: .5s;
    margin-top: -3px;
    &:hover {
        opacity: .5;
        cursor: pointer;
    }
}
`
